import { Box, Card, CardActionArea, CardMedia, FormLabel, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useProyecto } from '../../data/ProyectoContext';
import { useJobContext } from '../../hooks/Jobs';
import PersonPlayFilledIcon from '../../layout/Drawer/icons/PersonPlayFilledIcon';
import UnidadActivaImg from './img/UnidadActiva.png';
import ABPImg from './img/abp.png';

const TypeSelector = () => {
  const { proyecto, setProyecto } = useProyecto();
  const { resetState, handleSetTipoEstructuraProyecto } = useJobContext();

  const navigate = useNavigate();
  const handleUmmIAPlanABP = () => {
    resetState();
    setProyecto({ ...proyecto, tipo_estructura: 'Aprendizaje basado en proyectos', materias: [], objetivos_aprendizaje: [] });
    handleSetTipoEstructuraProyecto('aprendizaje_basado_en_proyectos');
    navigate("/asistente/editor");

  }

  const handleUmmIAPlanUnidadActiva = () => {
    resetState();
    setProyecto({ ...proyecto, tipo_estructura: 'Unidad Activa', materias: [], objetivos_aprendizaje: [] });
    handleSetTipoEstructuraProyecto('unidad_activa');
    navigate("/asistente/editor");
  }

  return (
    <Grid container spacing={2}
      sx={{ m: 'auto', }}>

      <Grid item align="center" lg={12}
        sx={{ mb: 2, paddingBottom: '15px', m: 'auto' }}>
        <Grid item xs={12} align="center" sx={{ mb: 2, paddingBottom: '15px' }}>
          <Grid item xs={12} align="center" display={'flex'} flexDirection={'row'} justifyContent={'center'}>
            <PersonPlayFilledIcon />
            <Typography variant="h3" component="h3" color="#336B87" fontWeight={'bold'} textAlign="center" sx={{ fontFamily: 'Montserrat' }}>
              UmmIAPlan
            </Typography>
          </Grid>
        </Grid>
        <Box>
          <FormLabel sx={{ fontFamily: 'Montserrat' }}>Por favor selecciona el tipo de planificación que deseas crear</FormLabel>
        </Box>
      </Grid>
      <Grid sx={{ m: 'auto', display: 'flex', flexDirection: 'row', width: '70%', height: '80%', p: 1 }}>















        <Grid item sx={{ display: 'flex', flexDirection: 'row', m: 'auto', p: 2 }}>
          

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ height: '230px', m: 2, display: 'flex', flexDirection: 'column' }}>
                    <Card sx={{
                        boxShadow: 3,
                        transition: 'transform 0.1s ease-in-out, box-shadow 0.3s ease-in-out',
                        ':hover': {
                            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
                            transform: 'scale(1.01)',
                        },
                        borderRadius: 5,
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: '100%',
                    }}>
                        <CardActionArea
                            onClick={handleUmmIAPlanABP}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                transition: 'transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out',
                            }}
                        >
                            <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                <CardMedia
                                    component="img"
                                    image={ABPImg}
                                    alt="Imagen UmmIA Plan"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>
                           
                        </CardActionArea>
                    </Card>
                </Grid>

                
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ height: '230px', m: 2, display: 'flex', flexDirection: 'column' }}>
                    <Card sx={{
                        boxShadow: 3,
                        transition: 'transform 0.1s ease-in-out, box-shadow 0.3s ease-in-out',
                        ':hover': {
                            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
                            transform: 'scale(1.01)',
                        },
                        borderRadius: 5,
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: '100%',
                    }}>
                        <CardActionArea
                            onClick={handleUmmIAPlanUnidadActiva}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                transition: 'transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out',
                            }}
                        >
                            <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                <CardMedia
                                    component="img"
                                    image={UnidadActivaImg}
                                    alt="Imagen UmmIA Plan"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>
                           
                        </CardActionArea>
                    </Card>
                </Grid>


        </Grid>
      </Grid>
    </Grid>
  );
};

export default TypeSelector;